import { ILabtestPrescription } from "@curefit/care-common";
import * as $ from "jquery";
import * as _ from "lodash";
import * as React from "react";
import CustomSelect from "../CustomSelect";
import TypeAhead, { TypeAheadElement, TypeAheadResults} from "../TypeAhead";
import IDiagnosticSuggestions from "../../models/IDiagnosticSuggestions";
import ModelFactory from "../../models/ModelFactory";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import { AppConstants, AppMessages, AppPlaceholders } from "../../utils/AppConstants";
import DurationComponent from "../DurationComponent";
import TextAreaAutoResize from "../TextAreaAutoResize";
import { ChangeEvent } from "react" 

/**
 * Created by aditya on 06/02/18.
 */

export interface LabTestItemEditorProps {
    consultationType: string,
    fetchStaticLabTestsData: (input: string) => Promise<any>,
    item: ILabtestPrescription;
    onDataChange: (update: any) => any
}

export interface LabTestItemEditorState {
    validate: boolean;
    labTestNameWarning: boolean;
}

class LabTestItemEditor extends React.Component<LabTestItemEditorProps, LabTestItemEditorState> {
    private labTestItemDOM: any;
    constructor(props: LabTestItemEditorProps) {
        super(props);
        let showLabTestWarning = ModelFactory.isValidLabTest(props.item);
        this.state = {
            validate: false,
            labTestNameWarning: showLabTestWarning
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.labTestItemDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.labTestItemDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onLabTestNameChange = (event: ChangeEvent<HTMLInputElement>, meta: any) => {
        // TODO Remove temp fix of lab code === name
        let updatedItem = Object.assign({}, this.props.item, {name: event.target.value, code: event.target.value});
        this.props.onDataChange(updatedItem);
    };

    onLabTestTypeAheadChange = (input: string) => {
        let typeAheadResults: TypeAheadResults;
        let typeAheadArray: TypeAheadElement[] = [];
        let updatedItem = {...this.props.item, name: input, code: "UNKNOWN"};
        this.props.onDataChange(updatedItem);
        this.setState({
            labTestNameWarning: false
        })
        return this.props.fetchStaticLabTestsData(input).then((results: IDiagnosticSuggestions[]): Promise<TypeAheadResults> => {
            if (results.length) {
                _.map(results, (diagnostic) => {
                    let additionalInfoLabel = !_.isEmpty(diagnostic.alternateNames) ? diagnostic.alternateNames.join(" | ") : undefined;
                    let typeAheadElement = {
                        value: diagnostic.code,
                        label: diagnostic.name,
                        additionalInfoLabel: additionalInfoLabel
                    }
                    typeAheadArray.push(typeAheadElement);
                })
                typeAheadResults = {options: typeAheadArray, completed: true};
                return Promise.resolve(typeAheadResults);
            } else {
                return Promise.resolve({options: [], completed: false});
            }
        }).catch((error: any) => {
            throw error;
        });
    };

    onLabTestTypeAheadSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, name: elem.label, code: elem.value};
        this.props.onDataChange(updatedItem);
    };

    onLabTestInstructionChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let updatedItem = Object.assign({}, this.props.item, {comment: event.target.value});
        this.props.onDataChange(updatedItem);
    };

    onLabTestFrequencyCountChange = (event: ChangeEvent<HTMLInputElement>) => {
        let frequencyItem = this.props.item.testDate !== null ? this.props.item.testDate : ModelFactory.createNewFrequency();
        frequencyItem.count = isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        let updatedItem = { ...this.props.item, testDate: frequencyItem };
        this.props.onDataChange(updatedItem);
    };

    onLabTestChange = (elem: TypeAheadElement) => {
        let duration = elem.others.value;
        let updatedItem = { ...this.props.item, testDate: duration };
        this.props.onDataChange(updatedItem);
    }

    onLabTestReminderChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, isImmediate: event.target.checked }
        this.props.onDataChange(updatedItem);
    }

    updateLabTestCondition = (value: string) => {
        let staticDataItem = ModelFactory.createNewStaticItem();
        staticDataItem.internalValue = value;
        staticDataItem.displayValue = AppConstants.LabtestConditions[value];
        let updatedItem = { ...this.props.item, testCondition: staticDataItem };
        this.props.onDataChange(updatedItem);
    }

    updateLabTestDays = (value: string) => {
        let frequencyItem = this.props.item.testDate !== null ? this.props.item.testDate : ModelFactory.createNewFrequency();
        frequencyItem.unit = value;
        let updatedItem = { ...this.props.item, testDate: frequencyItem };
        this.props.onDataChange(updatedItem);
    }

    updateWeeklySchedule = (days: string[]) => {
        let frequencyItem = this.props.item.testDate !== null ? this.props.item.testDate : ModelFactory.createNewFrequency();
        frequencyItem.weeklySchedule = days;
        let updatedItem = { ...this.props.item, testDate: frequencyItem };
        this.props.onDataChange(updatedItem)
    }

    handleLabTestNameBlur = (event: any) => {
        this.setState({
            labTestNameWarning: true
        })
    }

    generateConditionList() {
        let conditionList: IStaticDataValue[] = [];
        _.map(AppConstants.LabtestConditions, (type, key) => {
            let condition = ModelFactory.createNewStaticItem();
            condition.internalValue = key;
            condition.displayValue = type;
            conditionList.push(condition);
        })
        return conditionList;
    }

    generateLabTestDaysList() {
        let labTestWhen: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let item = ModelFactory.createNewStaticItem();
            item.internalValue = key;
            item.displayValue = type;
            labTestWhen.push(item);
        })
        return labTestWhen;
    }

    generateFrequencyListItems() {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        })
        return frequencyList;
    }

    render() {
        let consultationType = this.props.consultationType;
        let labTestName = this.props.item.name !== undefined && this.props.item.name !== null ? this.props.item.name : "";
        let labTestInstruction = !_.isEmpty(this.props.item.comment) ? this.props.item.comment : "";
        let labtestConditions = this.generateConditionList();
        let selectedCondition = this.props.item.testCondition !== null ? this.props.item.testCondition.displayValue : null;
        let labtestWhen = this.generateLabTestDaysList();
        let selectedLabTestWhen = this.props.item.testDate !== null ? this.props.item.testDate.unit : null;
        let labTestFrequencyCount = this.props.item.testDate !== null ? this.props.item.testDate.count : "";
        let labTestFrequencyWeeklySchedule = !_.isEmpty(this.props.item.testDate) && !_.isEmpty(this.props.item.testDate.weeklySchedule) ? this.props.item.testDate.weeklySchedule : [];
        let isImmediate = this.props.item.isImmediate;
        let labTestNameValidationStatus = this.state.validate && _.isEmpty(this.props.item.name) ? "error" : "";
        let labTestNameWarning = this.state.labTestNameWarning && this.props.item.code === "UNKNOWN" ? AppMessages.LAB_TEST_UNKNOWN_TEST_ERROR_MESSAGE : null;
        return (
            <div className="labTest-item-editor" ref={(labTestItemDOM) => this.labTestItemDOM = labTestItemDOM}>
                <div className={`labTest-editor-name ${labTestNameValidationStatus}`}>
                    {/*<TextInput name="labTest-name" value={labTestName} onChange={this.onLabTestNameChange} placeholder={AppPlaceholders.LAB_TESTS_EDITVIEW_NAME}/>*/}
                    <TypeAhead widgetName={"LabTestItem"} name={"labTest-name"} value={labTestName} placeholder={AppPlaceholders.DIAGNOSIS_EDITVIEW_NAME} onTypeAheadChange={this.onLabTestTypeAheadChange} onTypeAheadSelect={this.onLabTestTypeAheadSelect}
                                onTypeAheadBlur={this.handleLabTestNameBlur} errorText={labTestNameWarning}/>
                </div>
                <div className="labTest-editor-condition">
                    <CustomSelect dropdownValues={labtestConditions} selectedValue={selectedCondition} defaultValue={"select"} updateDropdownValue={this.updateLabTestCondition} />
                </div>
                <div className="labTest-editor-when">
                    <DurationComponent unit={selectedLabTestWhen} count={labTestFrequencyCount || "" as any}
                                       dropdownItems={this.generateFrequencyListItems()} rootClass={"labtest-frequency"}
                                       onCountChange={this.onLabTestFrequencyCountChange} onUnitChange={this.updateLabTestDays}
                                       onDurationChange={this.onLabTestChange}/>
                    {/*<div className={"labtest-frequency-count"}>
                        <TextInput name="labTest-name" value={labTestFrequencyCount || ""} onChange={this.onLabTestFrequencyCountChange} placeholder={AppPlaceholders.LAB_TESTS_EDITVIEW_FREQUENCY_COUNT}/>
                    </div>
                    <div className={"labtest-frequency-unit"}>
                        <CustomSelect dropdownValues={labtestWhen} selectedValue={selectedLabTestWhen} defaultValue={"select"} updateDropdownValue={this.updateLabTestDays} />
                    </div>*/}
                </div>
                <div className="labTest-editor-stat">
                    <input type="checkbox" onChange={this.onLabTestReminderChange} checked={isImmediate} />
                </div>
                <div className="labTest-editor-instructions">
                    <TextAreaAutoResize
                        name={"labTest-editor-instructions"}
                        className={"textarea-input form-control"}
                        value={labTestInstruction}
                        placeholder={AppPlaceholders.LAB_TESTS_EDITVIEW_INSTRUCTIONS}
                        onChange={this.onLabTestInstructionChange}
                    />
                </div>
                {/*{*/}
                    {/*consultationType === AppConstants.ConsultationTypes.KMH &&*/}
                    {/*<div className="labTest-editor-days">*/}
                        {/*<WeekdaySelector selectedDays={labTestFrequencyWeeklySchedule} onSelect={this.updateWeeklySchedule}/>*/}
                    {/*</div>*/}
                {/*}*/}
                {/*{*/}
                    {/*consultationType === AppConstants.ConsultationTypes.KMH &&*/}
                    {/*<div className="labTest-editor-reminder">*/}
                        {/*<input type="checkbox" onChange={this.onLabTestReminderChange} checked={this.props.item.remind} />*/}
                    {/*</div>*/}
                {/*}*/}
            </div>
        )
    }
}

export default LabTestItemEditor;
